document.addEventListener(
  "click",
  function (e) {
    const el = e.target.closest("a, summary");
    if (!el) return;

    const isDesktopMenu = el.closest(".nav-desktop__tier-1");
    const isMobileMenu = el.closest("#mobile_menu");

    if (!isDesktopMenu && !isMobileMenu) return;
    const clickedText = el.innerText.trim();
    const isDesktopSubmenu = !!el.closest(
      ".nav-desktop__tier-2, .nav-desktop__tier-3, .mega-menu",
    );
    const mobileListItem = isMobileMenu ? el.closest("li") : null;
    const mobileParentSublink = mobileListItem?.parentElement?.closest(
      "li.sublink",
    );
    const isMobileSubmenu = !!mobileParentSublink;
    const isSubmenu = isDesktopSubmenu || isMobileSubmenu;

    let menuSection = clickedText;
    let submenuSection = "";

    if (isSubmenu) {
      // Desktop submenu clicks should be attributed to the tier-1 menu section.
      if (isDesktopSubmenu) {
        const tier1Item = el.closest(".nav-desktop__tier-1-item");
        const tier1Title = tier1Item
          ?.querySelector("[data-nav-desktop-link] [data-nav-title]")
          ?.textContent?.trim();

        menuSection = tier1Title || clickedText;
        submenuSection = clickedText;
      } else {
        // Mobile submenu clicks should use the parent sublink title as section.
        const mobileTitle =
          mobileParentSublink
            ?.querySelector("[data-nav-title]")
            ?.textContent?.trim() ||
          mobileParentSublink?.querySelector("a")?.textContent?.trim();

        menuSection = mobileTitle || clickedText;
        submenuSection = clickedText;
      }
    }

    Shopify.analytics.publish("menu_bar_interaction", {
      menu_section: menuSection.toUpperCase(),
      submenu_section: submenuSection.toUpperCase(),
      page_path: window.location.pathname,
      page_title: document.title,
      page_location: window.location.href,
    });
  },
  true,
);

(function () {
  let lastTrackedKey = "";
  let lastTrackedAt = 0;
  let lastResultsQuery = null;
  let pendingPublish = null;
  let flushTimer = null;

  function buildProductPayload(product) {
    if (!product || typeof product !== "object") return null;

    const productId = product.original_product_id || product.product_id;
    const title = product.title || product.product_title;
    const url = product.link || product.url || product.product_url;
    const price = product.price;
    const vendor = product.vendor;
    const image = product.image_link || product.image || product.thumbnail;

    const payload = {
      clicked_from: "instant_search",
    };

    if (productId != null && productId !== "") {
      payload.product_id = String(productId);
    }
    if (title) payload.product_title = String(title);
    if (url) payload.product_url = String(url);
    if (price != null && price !== "") payload.product_price = String(price);
    if (vendor) payload.product_vendor = String(vendor);
    if (image) payload.product_image = String(image);

    return payload;
  }

  function doPublish(term, extra) {
    if (!window.Shopify?.analytics?.publish) return false;

    const now = Date.now();
    const productId = extra?.product_id || "";
    const dedupeKey = term + "|" + productId;

    // Avoid double-firing when form submit + Searchanise + URL fallback overlap.
    if (dedupeKey === lastTrackedKey && now - lastTrackedAt < 2000) return true;

    lastTrackedKey = dedupeKey;
    lastTrackedAt = now;

    const payload = Object.assign({ search_term: term }, extra || {});

    // Visible without wrapping Shopify.analytics — remove once verified.
    console.log("✅ search_submitted", payload);

    Shopify.analytics.publish("search_submitted", payload);
    return true;
  }

  function publishSearchSubmitted(searchTerm, extra) {
    const term = String(searchTerm || "").trim();
    if (!term) return;

    if (doPublish(term, extra)) {
      pendingPublish = null;
      return;
    }

    // Shopify.analytics often isn't ready yet on first paint — retry.
    pendingPublish = { term: term, extra: extra || null };
    if (flushTimer) return;

    const startedAt = Date.now();
    flushTimer = setInterval(function () {
      if (!pendingPublish) {
        clearInterval(flushTimer);
        flushTimer = null;
        return;
      }
      if (doPublish(pendingPublish.term, pendingPublish.extra)) {
        pendingPublish = null;
        clearInterval(flushTimer);
        flushTimer = null;
        return;
      }
      if (Date.now() - startedAt > 15000) {
        clearInterval(flushTimer);
        flushTimer = null;
      }
    }, 100);
  }

  function getSearchTermFromForm(form) {
    return form
      ?.querySelector(".search-form__input, input[name='q']")
      ?.value?.trim();
  }

  function trackResultsQuery(term) {
    const value = String(term || "").trim();
    if (!value) return;

    // Facet/sort updates reuse the same query — don't recount as a new search.
    if (value === lastResultsQuery) return;
    lastResultsQuery = value;
    publishSearchSubmitted(value);
  }

  // Native form submit fallback (all search forms, capture phase).
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const isSearchForm =
        form.classList.contains("search-form") ||
        !!form.querySelector('input[name="q"]');
      if (!isSearchForm) return;

      const value = getSearchTermFromForm(form);
      if (value) publishSearchSubmitted(value);
    },
    true,
  );

  // Per Searchanise docs: bind other listeners inside Searchanise.Loaded
  // using window.Searchanise.$ (their jQuery), not window.jQuery.
  // https://docs.searchanise.io/js-api-events/
  function bindSearchaniseSearchTracking($) {
    if (!$ || window.__searchaniseSearchTrackingBound) return;
    window.__searchaniseSearchTrackingBound = true;

    $(document).on(
      "Searchanise.DataRequestBefore",
      function (_event, type, params) {
        if (type !== "results") return;
        trackResultsQuery(params?.q);
      },
    );

    $(document).on(
      "Searchanise.DataRequestEnd",
      function (_event, type, params) {
        if (type !== "results") return;
        trackResultsQuery(params?.q);
      },
    );

    $(document).on("Searchanise.ResultsUpdated", function () {
      const urlTerm = new URL(window.location.href).searchParams.get("q");
      trackResultsQuery(urlTerm);
    });

    // User typed a query and clicked a recommended product (no submit).
    // Args from Searchanise: [element, input, product, original_query]
    $(document).on(
      "Searchanise.ProductIswClicked",
      function (_event, _el, input, product, query) {
        const term =
          query ||
          (input && typeof input.val === "function" ? input.val() : "") ||
          "";
        publishSearchSubmitted(term, buildProductPayload(product));
      },
    );

    // Suggestion / category / page clicks in the Instant Search dropdown.
    // Product clicks are handled by ProductIswClicked (with product data).
    $(document).on(
      "click",
      ".snize-ac-results a",
      function () {
        if ($(this).closest(".snize-product").length) return;

        const $results = $(this).closest(".snize-ac-results");
        const $input = $results.data("snize_search_input");
        const term =
          ($input && typeof $input.val === "function" && $input.val()) ||
          document.querySelector(".search-form__input.snize-input-style")
            ?.value ||
          "";
        publishSearchSubmitted(term, {
          clicked_from: "instant_search_suggestion",
        });
      },
    );
  }

  document.addEventListener("Searchanise.Loaded", function () {
    (function ($) {
      bindSearchaniseSearchTracking($);
    })(window.Searchanise.$);
  });

  // If Searchanise already finished loading before this script ran.
  if (window.Searchanise && window.Searchanise.$ && window.Searchanise.Loaded) {
    bindSearchaniseSearchTracking(window.Searchanise.$);
  } else {
    // Fallback poll — Loaded can finish before listeners attach.
    const startedAt = Date.now();
    const timer = setInterval(function () {
      if (window.Searchanise && window.Searchanise.$) {
        clearInterval(timer);
        bindSearchaniseSearchTracking(window.Searchanise.$);
        return;
      }
      if (Date.now() - startedAt > 20000) clearInterval(timer);
    }, 100);
  }

  // Results page fallback: Searchanise lands on /pages/search-results-page?q=...
  function trackResultsPageFromUrl() {
    const url = new URL(window.location.href);
    const isSearchResultsPage =
      url.pathname.indexOf("search-results-page") !== -1 ||
      url.pathname === "/search";
    const term = url.searchParams.get("q");

    if (isSearchResultsPage && term) {
      publishSearchSubmitted(term);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", trackResultsPageFromUrl);
  } else {
    trackResultsPageFromUrl();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = new URL(window.location.href);
  const pageNumber = currentUrl.searchParams.get("page");
  const navEntry = performance.getEntriesByType("navigation")[0];
  const isReload = navEntry?.type === "reload";

  if (!pageNumber || isReload) return;

  Shopify.analytics.publish("pagination", {
    value: String(pageNumber).toUpperCase(),
    page_path: currentUrl.pathname + currentUrl.search,
    page_title: document.title,
    page_location: currentUrl.href,
  });
});


